import { plainToClass } from "class-transformer";
import { DeliverableChildExtended, DeliverableParentExtended, DeliverablesCommentConfig, DeliverableComment } from "./deliverables-tracker.objects";
import { JsonItem, PickListItem } from "../../list-management/scripts/list-management.objects";
import { getDisplayDate } from "../../../shared/scripts/date-functions";

export class EditDeliverablesCommentController {
    // Config
    modalId: string;
    getCommentsChildRoute: string;
    postCommentChildRoute: string;

    // Variables
    currentChild: DeliverableChildExtended;
    currentComments: DeliverableComment[];
    pickLists: JsonItem[];
    userPickList: PickListItem[];


    constructor(config: DeliverablesCommentConfig) {
        this.modalId = config.modalIdTarget;
        this.getCommentsChildRoute = config.getCommentsChildRoute;
        this.postCommentChildRoute = config.postCommentChildRoute;
    }

    async initialize(currentItem: any) {
        this.showSaving(false);
        this.showLoading(true);

        this.currentComments = [];
        this.currentChild = undefined;
        this.pickLists = [];


        this.currentChild = <DeliverableChildExtended>currentItem;

        let result = await this.getCommentsChild(this.currentChild);
        if (result["items"]) {
            this.currentComments = plainToClass(DeliverableComment, <DeliverableComment[]>result["items"]);
        }
        if (result["pickLists"]) {
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>result["pickLists"]);
        }


        let foundUserList = this.pickLists.find(list => list.Id.includes("user"))?.Json;
        if (foundUserList) {
            this.userPickList = foundUserList;
        }

        this.generateHtml();

        this.showLoading(false);
    }

    // After adding a new comment
    async updateComments() {
        this.currentComments = [];
        let result = await this.getCommentsChild(this.currentChild);
        if (result["items"]) {
            this.currentComments = plainToClass(DeliverableComment, <DeliverableComment[]>result["items"]);
        }
        this.updateCommentHtml();
        this.showSaving(false);
    }

    async getCommentsChild(child: DeliverableChildExtended) {
        let result: any;
        try {
            result = await $.ajax(this.getCommentsChildRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(child.DeliverableChild.Id) }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    updateCommentHtml(): void {
        let commentContent = this.createCommentTable();
        $(`#${this.modalId}`).find('.deliverable-comment-table').empty().html(commentContent);
    }

    createCommentTable(): string {
        let currentComments = "";
        if (this.currentComments.length == 0) {
            currentComments = `<div class='text-center font-size16 font-weight-500'>No Comments</div>`;
        }
        else {
            this.currentComments.sort((x1, x2) => {
                let time1 = new Date(x1.Date).getTime();
                let time2 = new Date(x2.Date).getTime();
                return time2 - time1;
            })
            this.currentComments.forEach(comment => {
                let foundUser = this.userPickList.find(user => user.Id == comment.AppUserId);
                let userInfo = "";
                if (foundUser) {
                    userInfo = foundUser.Value;
                }

                let commentContent = `
                    <div class="deliverable-comment-row">
                        <div class="d-flex justify-content-between">
                            <div class="deliverable-comment-user">${userInfo}</div>
                            <div class="deliverable-comment-date">${getDisplayDate(comment.Date)}</div>
                        </div>
                        <div class="deliverable-comment-comment"> 
                            ${comment.Comment}
                        </div>
                    </div>  
                `
                currentComments += commentContent;
            })
        }
        return currentComments;
    }

    generateHtml(): void {
        let addCommentSection = `
            <div class="col-12">
                <div id="add-deliverable-comment-container" class="form-group">
                    <textarea class="form-control col-12 font-size14" rows="3" id="add-deliverable-comment-input"></textarea>
                </div>
            </div>
            <div class="col-12">
                <button class="greenbtn btn btn-sm disabled" type="button" id="add-deliverable-comment-btn">Add Comment</button>
                <div id="add-comment-saving-spinner" class="spinner-border d-none" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        `     

        let currentComments = this.createCommentTable();

        let description = "";
        if (this.currentChild) {
            description = `<p class="font-italic">${this.currentChild.DeliverableChild.Description}</p>`;
        }

        let commentContent = `
            <div class="col-12">
                <div class="modal-title">Comments</div>
                ${description}
            </div>
            ${addCommentSection}
            <div class="col-12 mt-3 mb-2">
                <div class="deliverable-comment-table">
                    ${currentComments}
                </div>
            </div>
        `

        $(`#${this.modalId}`).find('.edit-comment-container').empty().html(commentContent);

        this.initializeComments();
    }

    initializeComments(): void {
        $(`#${this.modalId}`).find("#add-deliverable-comment-input").off().on("change keyup", () => {
            let val = <string>$(`#${this.modalId}`).find("#add-deliverable-comment-input").val();
            if (val.trim() != "") {
                $(`#${this.modalId}`).find("#add-deliverable-comment-btn").removeClass("disabled");
            }
            else {
                $(`#${this.modalId}`).find("#add-deliverable-comment-btn").addClass("disabled");
            }
        });

        $(`#${this.modalId}`).find("#add-deliverable-comment-btn").off().on("click", async () => {
            if ($(`#${this.modalId}`).find("#add-deliverable-comment-btn").hasClass("disabled")) {
                return;
            }
            // Save Comment
            this.showSaving(true);
            let commentVal = <string>$(`#${this.modalId}`).find("#add-deliverable-comment-input").val();
            $(`#${this.modalId}`).find("#add-deliverable-comment-input").val("").trigger("change");
            let result = await this.saveComment(commentVal);
            this.updateComments();
        })
    }

    async saveComment(commentVal: string): Promise<any> {
        let newComment: DeliverableComment = {
            Id: 0,
            Date: new Date(), // Updated on backend
            AppUserId: 0, // Updated on backend
            ChildId: this.currentChild.DeliverableChild.Id,
            ParentId: this.currentChild.DeliverableChild.ParentId,
            Comment: commentVal
        }

        let result: any;
        try {
            result = await $.ajax(this.postCommentChildRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(newComment) }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    showLoading(isLoading: boolean) {
        if (isLoading) {
            $(`#${this.modalId}`).find("#edit-comment-content").addClass("d-none");
            $(`#${this.modalId}`).find("#edit-comment-loading").removeClass("d-none");
        }
        else {
            $(`#${this.modalId}`).find("#edit-comment-content").removeClass("d-none");
            $(`#${this.modalId}`).find("#edit-comment-loading").addClass("d-none");
        }
    }

    showSaving(isSaving: boolean) {
        if (isSaving) {
            $(`#${this.modalId}`).find("#add-comment-saving-spinner").removeClass("d-none");
            $(`#${this.modalId}`).find("#add-deliverable-comment-btn").addClass("d-none");
        }
        else {
            $(`#${this.modalId}`).find("#add-comment-saving-spinner").addClass("d-none");
            $(`#${this.modalId}`).find("#add-deliverable-comment-btn").removeClass("d-none");
        }
    }
}